/*globals jQuery */

/**
 * Gather which images with the data-src attr are in view
 * @returns {array} List of images in view
 */
function gatherInViewImgs() {
    "use strict";
    var inViewImgs = [],
        $this;

    jQuery("img[data-src]").each(function (i, obj) {
        $this = jQuery(obj);

        if (isScrolledIntoView($this)) {
            inViewImgs.push($this);
        }
    });
    return inViewImgs;
}

/**
 * Load the images's src of only the images that are in view
 */
function loadImgs() {
    "use strict";
    var imgs = gatherInViewImgs(),
        imgSrc,
        $this;

    jQuery.each(imgs, function (i, obj) {
        $this = jQuery(obj);
        imgSrc = $this.attr("data-src");

        $this[0].src = imgSrc;
        console.log("loading img with src: " + imgSrc);
        $this.removeAttr("data-src").css("opacity", "1").removeClass("loading");
    });
}

/**
 * Checks if an element (currently jQuery) is scrolled into view
 * @param   {object}   elem (jQuery) DOM element
 * @param   {boolean}  full
        (FALSE [default]) check if top of element has been scrolled past (will return FALSE if element above scroll view)
        (TRUE) check if full element in scrolled view
 * @returns {boolean} Whether the element is in view
 */
function isScrolledIntoView(elem, full) {
    "use strict";

    if (elem.length < 1) {
        return false;
    }

    var $elem = elem,
        docViewTop = jQuery(window).scrollTop(),
        docViewBottom = docViewTop + jQuery(window).height(),

        elemTop = $elem.attr("data-offset-top") > 0 ? parseInt($elem.attr("data-offset-top"), 10) : 0,
        elemBottom;

    if (elemTop === 0 && elem[0].offsetParent) {
        elem = elem[0];
        do {
            elemTop += elem.offsetTop;
            elem = elem.offsetParent;
        } while (elem);
    }
    elemBottom = elemTop + $elem.height();
    $elem.attr("data-offset-top", elemTop);

    if (full) {
        return (elemBottom < docViewBottom);
    }
    return (elemTop < docViewBottom);
}

/* Call */
loadImgs();

jQuery(window).scroll(function (e) {
    "use strict";
    loadImgs();
});

jQuery(window).resize(function (e) {
    "use strict";
    loadImgs();
});